import moment from 'moment'
import React, {FC, useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'
import { KTSVG, useDebounce} from '../../../../../_metronic/helpers'
import {
  DeleteData,
  GetAllData,
} from './TagSlice/TagsSlices'
import {startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import CreateTagsPopup from './Modal/CreateTagsPopup'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
// import Select from 'react-select'
import InsertNewData from '../../../../Components/InsertNewData'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {toast} from 'react-toastify'
import {useListTag} from './useListTagHooks'
import {Tag} from '../../../../../services/cellcast.v3.types'
import TagFilter from './TagFilter'

interface TagsPageProps {
  newNavigation?: boolean
  setTotal?: (value?: number) => void
}

export type TagParams = {
  page?: number
  size?: number
  search?: string
}


const TagsList: FC<TagsPageProps> = ({ newNavigation, setTotal }) => {
  const {fetchTagsData, tagslist} = useListTag()
  const [isShowPaginate, setShowPaginate] = useState(true)

  const API_URL = ENV().REACT_APP_API_URL
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const navigate = useNavigate()

  const dispatch = useDispatch()
  const [createTag, setCreateTag] = useState(false)
  const [tagName, setTagName] = useState({})

  //Delete All state
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()

  const [params, setParams] = useState<TagParams>({
    page: 1,
    size: 10,
    search: '',
  })

  useEffect(() => {
    fetchTagsData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (tagslist && tagslist.totalPages === 0) {
      setShowPaginate(false)
    }
  }, [tagslist])

  useEffect(() => {
    if (setTotal &&  tagslist?.total !== undefined) {
      setTotal(tagslist?.total ?? 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagslist?.total])
  
  const debouncedSearchTerm = useDebounce(params?.search, 3000)
  useEffect(() => {
    dispatch(startLoadding())
    dispatch(GetAllData(params))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, params.page, params.size])

  useEffect(() => {
    if (confirm === true) {
       dispatch(
          DeleteData({
            tagIds: [...deleteIds],
          })
        )

      setConfirm(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  const createTagPopup = useMemo(
    () => (
      <CreateTagsPopup
        tagName={tagName}
        setTagName={setTagName}
        show={createTag}
        callback={() =>
          fetchTagsData({
            ...params,
            page: parseInt(String(params.page)),
            size: parseInt(String(params.size)),
            search: params.search ?? '',
          })
        }
        handleClose={() => setCreateTag(false)}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [createTag, tagName]
  )
  const handleEdit = (val: any) => {
    setTagName({
      id: val?._id,
      name: val?.name,
      industry: val?.industry,
      affiliate: val?.affiliate,
      color: val?.color,
    })
    setCreateTag(true)
  }

  const handleSingleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds([id])
  }
  
  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={params}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => {}}
        Message={'Are you sure, you want to delete Tag?'}
        confirm={() => setConfirm(true)}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open]
  )

  const handleExport = (e: any) => {
    axios
      .get(`${API_URL}tags/exportTagContacts/${e}`, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res: any) => {
        window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self')
      })
  }

  return (
    <>
      {confirmation}
      {createTagPopup}

      <div className='card mb-0'>
        <div className='card-header border-0 pt-12 d-flex flex-column'>
          {!newNavigation && (
            <h3 className='card-title align-items-start flex-column mb-0'>
              <span className='card-label fw-bolder fs-2 mb-1'>Tags</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Here you can see all base tags</span>
            </h3>
          )}

          <div className='d-flex justify-content-between align-items-center'>
            <TagFilter params={params} setParams={setParams} doFetch={() => dispatch(GetAllData(params))} />
            {AuthenticateUser('create-tag') && (
              <div className='ms-auto'>
                <button
                  className='btn btn-primary'
                  onClick={() => {
                    setTagName('')
                    setCreateTag(true)
                  }}
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  Create
                </button>
              </div>
            )}
          </div>
        </div>
        {tagslist?.items?.length > 0 ? (
          <div className='card-body pt-2 pb-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>TAG NAME</th>
                      <th>INDUSTRY</th>
                      <th>AFFILIATE</th>
                      <th>DATE</th>
                      <th>TIME</th>
                      <th className='w-100px'>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {tagslist?.items?.map((val: Tag, i: number) => (
                      <tr key={i}>
                        <td
                          onClick={() => {
                            navigate('/filterContact', {state: val?._id})
                          }}
                          className='fw-bold cursor-pointer px-2'
                        >
                          <span
                            key={i}
                            className='btn'
                            style={{
                              color: val?.color ? 'white' : 'black',
                              backgroundColor: val?.color ? val?.color : '',
                            }}
                          >
                            {val?.name}
                          </span>
                        </td>
                        <td>{val?.industry}</td>
                         <td>{val?.affiliate}</td>
                        <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                        <td>{moment(val?.createdAt).format('LT')}</td>
                        <td>
                          <div className='row'>
                            {AuthenticateUser('edit-tag') && (
                              <div
                                className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                onClick={() => handleEdit(val)}
                              >
                                <span className='svg-icon svg-icon-3'>
                                  <i className='bi bi-pencil-fill'></i>
                                </span>
                              </div>
                            )}
                            <span
                              className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                              data-kt-menu-trigger='hover'
                              data-kt-menu-placement='bottom-end'
                            >
                              <i className='bi bi-three-dots fs-5'></i>
                            </span>
                            <div
                              className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                              data-kt-menu='true'
                            >
                              {(AuthenticateUser('export-tagged-contacts')) && (
                                <div
                                  onClick={() => handleExport(val?._id)}
                                  className='menu-item px-3'
                                >
                                  <span className='menu-link px-3 aside-footer flex-column-auto'>
                                    Export as CSV
                                  </span>
                                </div>
                              )}
                              <div className='menu-item px-3'>
                                <span
                                  className='menu-link px-3'
                                  onClick={() => {
                                    navigator.clipboard.writeText(val?._id)
                                    toast.success('Successfully copied tag id')
                                  }}
                                  data-kt-users-table-filter='copy_row'
                                >
                                  Copy ID
                                </span>
                              </div>
                              {AuthenticateUser('delete-tag') && (
                                <div className='menu-item px-3'>
                                  <span
                                    className='menu-link px-3 text-danger'
                                    onClick={() => handleSingleDelete(val?._id)}
                                    data-kt-users-table-filter='delete_row'
                                  >
                                    Delete
                                  </span>
                                </div>
                              )}

                              {/* end::Menu item */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <InsertNewData
            message={{
              title: `No Tag setup (yet!)`,
              subtitle: `Create a base tag to get started`,
            }}
            buttonName={{
              name: 'Create tag',
              link: '',
              popup: true,
              buttonFun: () => setCreateTag(true),
            }}
          />
        )}

        {isShowPaginate && (
          <div className='abcd ps-10 pe-5 pb-5'>
            <select onChange={(e: any) => setParams({...params, size: e.target.value, page: 1})}>
              <option value={10} selected={params.size === 10}>
                10
              </option>
              <option value={20} selected={params.size === 20}>
                20
              </option>
              <option value={50} selected={params.size === 50}>
                50
              </option>
              <option value={tagslist?.total}>ALL</option>
            </select>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={tagslist?.totalPages}
              onPageChange={(e) => setParams({...params, page: e.selected + 1})}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default TagsList
